// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n.page-link {\n  cursor: pointer;\n}", "",{"version":3,"sources":["styles.scss"],"names":[],"mappings":"AAAA,8EAAA;AAEA;EACI,eAAA;AAAJ","file":"styles.scss","sourcesContent":["/* You can add global styles to this file, and also import other style files */\n\n.page-link{\n    cursor: pointer;\n}\n"]}]);
// Exports
module.exports = exports;
